import { Handshake } from 'lucide-react';
import { Select } from '@/components/forms/Select';
import {
  BOOLEAN_SELECT_OPTIONS,
  INVOLVEMENT_LEVEL_OPTIONS,
  PARTNER_RELATIONSHIP_QUALITY_OPTIONS,
} from '@/components/establishments/establishment-configs';
import type { EstablishmentFormState } from '@/types/establishment.types';

/** Props for {@link EstablishmentPartnershipSection}. */
interface Props {
  form: EstablishmentFormState;
  onFieldChange: (field: string, value: unknown) => void;
}

/** Partner relationship quality and involvement. */
export function EstablishmentPartnershipSection({ form, onFieldChange }: Readonly<Props>) {
  function handleConventionChange(value: string): void {
    onFieldChange('conventionSigned', value);
  }
  function handleDevoirsFaitsChange(value: string): void {
    onFieldChange('hasDevoirsFaits', value);
  }
  function handleInternatChange(value: string): void {
    onFieldChange('hasInternat', value);
  }
  function handleInvolvementChange(value: string): void {
    onFieldChange('involvementLevel', value);
  }
  function handleRelationshipChange(value: string): void {
    onFieldChange('partnerRelationshipQuality', value);
  }

  return (
    <div className="form-section">
      <h4 className="form-section-title">
        <Handshake className="w-4 h-4" />
        Dispositifs & Partenariat
      </h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Select
          label="Convention signée"
          value={form.conventionSigned}
          onChange={handleConventionChange}
          options={BOOLEAN_SELECT_OPTIONS}
          placeholder="Non renseigné"
          size="sm"
        />
        <Select
          label="Présence dispositif Devoirs Faits"
          value={form.hasDevoirsFaits}
          onChange={handleDevoirsFaitsChange}
          options={BOOLEAN_SELECT_OPTIONS}
          placeholder="Non renseigné"
          size="sm"
        />
        <Select
          label="Présence internat"
          value={form.hasInternat}
          onChange={handleInternatChange}
          options={BOOLEAN_SELECT_OPTIONS}
          placeholder="Non renseigné"
          size="sm"
        />
        <Select
          label="Niveau d'implication établissement"
          value={form.involvementLevel}
          onChange={handleInvolvementChange}
          options={INVOLVEMENT_LEVEL_OPTIONS}
          placeholder="Non renseigné"
          size="sm"
        />
        <Select
          label="Qualité relation partenaire"
          value={form.partnerRelationshipQuality}
          onChange={handleRelationshipChange}
          options={PARTNER_RELATIONSHIP_QUALITY_OPTIONS}
          placeholder="Non renseigné"
          size="sm"
        />
      </div>
    </div>
  );
}
